export default "dist/images/block-columns-uneven.579e051.png";